import { render, staticRenderFns } from "./AccountNegativeIvm.vue?vue&type=template&id=466a6efa&scoped=true&"
import script from "./AccountNegativeIvm.ts?vue&type=script&lang=ts&"
export * from "./AccountNegativeIvm.ts?vue&type=script&lang=ts&"
import style0 from "./AccountNegativeIvm.vue?vue&type=style&index=0&id=466a6efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a6efa",
  null
  
)

export default component.exports